import { defaultCity } from "@constants/cities";
import Cookies from "js-cookie";
import { addCookieToWebView } from "@hooks/useWebviewCallback";
import { inApp } from "@utils/platformDetection.client";

type CityCookie = {
  id: number;
  name: string;
  slug: string;
};

const COOKIE_NAME = "selected_city";
const CITY_SLUG_COOKIE_NAME = "city_slug"; // NEW: Separate cookie for city_slug

const DEFAULT_CITY: CityCookie = {
  id: defaultCity.id,
  name: defaultCity.name,
  slug: defaultCity.city_slug,
};
const CITY_COOKIE_OPTIONS = {
  expires: 365,
  sameSite: "lax" as const,
};

export const getSelectedCityClient = (): CityCookie => {
  const raw = Cookies.get(COOKIE_NAME);

  if (raw) {
    try {
      const parsed = JSON.parse(raw);
      if (parsed?.id && parsed?.name && parsed?.slug) {
        return parsed as CityCookie;
      }
    } catch (err) {
      console.warn("selected_city cookie is corrupted. Resetting to default.");
    }
  }

  // If not found or malformed, set and return default city
  setSelectedCityClient(DEFAULT_CITY);
  return DEFAULT_CITY;
};

export const setSelectedCityClient = (city: CityCookie): void => {
  const selectedCityValue = JSON.stringify(city);
  Cookies.set(COOKIE_NAME, selectedCityValue, CITY_COOKIE_OPTIONS);

  Cookies.set(CITY_SLUG_COOKIE_NAME, city.slug, CITY_COOKIE_OPTIONS);

  if (inApp()) {
    addCookieToWebView(COOKIE_NAME, selectedCityValue);
    addCookieToWebView(CITY_SLUG_COOKIE_NAME, city.slug);
  }
};
